export default "__VITE_ASSET__BTIw4SGm__"